<script setup lang="ts">

import Leaderboard from '@presentation/Icons/Leaderboard.vue';
import Reports from '@presentation/Icons/Reports.vue';
import Service from '@presentation/Icons/Service.vue';
import UnlimitedApps from '@presentation/Icons/UnlimitedApps.vue';

</script>

<template>

    <Page>

        <div class="grid grid-cols-1 lg:grid-cols-8 justify-center items-center gap-8 2xl:gap-16">

            <div class="col-span-1 lg:col-span-5 flex flex-wrap gap-y-6 2xl:gap-y-10">

                <div class="flex flex-col items-center basis-1/2 text-center py-2 px-4">
                    <Service class="w-10 2xl:w-16 text-[#2b85be]" />
                    <h1 class="font-bold 2xl:my-2 text-sm md:text-base lg:text-lg 3xl:text-2xl">PROTECT Car Parc</h1>
                    <h2 class="text-xs 2xl:text-sm 3xl:text-base">
                        Stay ahead of upcoming maintenance and service schedules, ensuring 
                        customers return to your dealership for all their needs.
                    </h2>
                </div>

                <div class="flex flex-col items-center basis-1/2 text-center py-2 px-4">
                    <UnlimitedApps class="w-10 2xl:w-16 text-[#2b85be]" />
                    <h1 class="font-bold 2xl:my-2 text-sm md:text-base lg:text-lg 3xl:text-2xl">Easy to Use</h1>
                    <h2 class="text-xs 2xl:text-sm 3xl:text-base">
                        Live dealership front-end system for business managers, fast, and simple to process new and existing contracts.
                    </h2>
                </div>

                <div class="flex flex-col items-center basis-1/2 text-center py-2 px-4">
                    <Reports class="w-10 2xl:w-16 text-[#2b85be]" />
                    <h1 class="font-bold 2xl:my-2 text-sm md:text-base lg:text-lg 3xl:text-2xl">KPI's &amp; Reporting</h1>
                    <h2 class="text-xs 2xl:text-sm 3xl:text-base">
                        Track and compare your dealerships, clear revenue earnings, transparent program performance.
                    </h2>
                </div>

                <div class="flex flex-col items-center basis-1/2 text-center py-2 px-4">
                    <Leaderboard class="w-10 2xl:w-16 text-[#2b85be]" />
                    <h1 class="font-bold 2xl:my-2 text-sm md:text-base lg:text-lg 3xl:text-2xl">Staff Leaderboards</h1>
                    <h2 class="text-xs 2xl:text-sm 3xl:text-base">
                        Performance leaderboards by Team and Business Manager to 
                        boost sales and penetration.
                    </h2>
                </div>

            </div>

            <div class="col-span-1 lg:col-span-3 flex flex-col gap-10 items-center">


                <Image
                    src="/WhatIsCarbucks/carparc-dashboard.png"
                    class="w-full mx-auto"
                    floor-shadow
                />

            </div>

        </div>

    </Page>

</template>